import axios from 'axios'

export default {
    async create(model) {
        return await axios.post(`item-type-group`, model)
    },
    async fetchById(id) {
        return await axios.get(`item-type-group/${id}`)
    },
    async fetch(query, page) {
        return await axios.get(`item-type-group?q=${query}&page=${page}`)
    },
    async fetchDrivers() {
        return await axios.get(`user`)
    },
  
    async update(id, model) {
        return await axios.put(`item-type-group/${id}`, model)
    },
    async delete(id) {
        return await axios.delete(`item-type-group/${id}`)
    },
}
